import {
  needOpenHotelPopunder,
  saveHotelsPopunderOpened,
  isHotelsPopunderOpened,
} from './cookieLogic';
import generateHotelPopunderLink from './generateHotelPopunderLink';
import { parseDateStringUTC, add } from '@ott/utility-date';
import KM from '@ott/utility-km';
import Cookie from 'js-cookie';
import { getOptions } from '../options';

const euroRailwaysCountries = [
  'CZ',
  'GB',
  'ES',
  'SE',
  'NO',
  'LU',
  'IT',
  'NL',
  'CH',
  'DE',
  'FR',
  'BE',
  'PT',
];

function checkEuroRailways(fromCountry, toCountry) {
  return euroRailwaysCountries.includes(fromCountry) && euroRailwaysCountries.includes(toCountry);
}

export function isOpenHotelsPopunder(values, data, isMobile) {
  const { from, to } = values;

  const isRoundTrip = data.date && data.returnDate;
  const isPopunderOpened = isHotelsPopunderOpened();
  const isEuroRailways = checkEuroRailways(from.country, to.country);

  if (
    !getOptions().enableHotelsPopunder ||
    isMobile ||
    isRoundTrip ||
    isEuroRailways ||
    isPopunderOpened
  ) {
    return false;
  }

  return needOpenHotelPopunder();
}

export function openHotelsPopunder(searchUrl, values, data) {
  const { to, adults, children } = values;

  const { date, returnDate } = data;

  const startDate = parseDateStringUTC(date);
  const endDate = returnDate ? parseDateStringUTC(returnDate) : add(startDate, 7, 'days');
  const link = generateHotelPopunderLink({
    startDate,
    endDate,
    adults,
    children,
    to: to.id,
  });

  KM('RZD_HOTEL_POPANDER_SHOW', {
    obj: {
      vid: Cookie.get('vid'),
      referrer: Cookie.get('referrer'),
      rederrer_mrk: Cookie.get('rederrer_mrk'),
      Envid: Cookie.get('ENVID'),
    },
  });

  saveHotelsPopunderOpened();

  window.open(`/ru/poezda${searchUrl}`);

  window.location.href = link;
}
